import Codeshare from './Codeshare';

export default Codeshare;
